import { Trans } from "react-i18next";
import Typography from "@mui/material/Typography";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { useTheme } from "@mui/material/styles";
const useStyles = makeStyles((theme) => ({
    jobName: {
        color: theme.palette.primary.dark,
        textAlign: "center",
        fontStyle: "italic",
        fontSize: "15px",
        fontWeight: "normal",
        marginTop: "2px",
    },
    headerSection: {
        marginBottom: theme.spacing(2),
    },
    newPictureSet: {
        color: theme.palette.primary.dark,
        textAlign: "center",
        fontSize: "15px",
        fontWeight: "bold",
    },
}));
const PictureSetHeading = ({ pictureSet }) => {
    const classes = useStyles();
    const theme = useTheme();
    return (React.createElement("section", { "aria-labelledby": "subject-name", className: classes.headerSection },
        React.createElement("div", { className: classes.newPictureSet },
            React.createElement(Trans, null, "Picture set")),
        React.createElement(Typography, { id: "subject-name", variant: "h1", color: "primary", sx: {
                textAlign: "center",
                fontWeight: 300,
                color: theme.palette.primary.dark,
                fontSize: "30px",
            } }, pictureSet.subject.name),
        React.createElement("h2", { className: classes.jobName }, pictureSet.job.name)));
};
export default PictureSetHeading;
